/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Helmet } from "react-helmet";
import Canonical from "../../../../components/common/layout/Canonical";
import { useTranslation } from "react-i18next";
import CorporateBanner from "../../../../components/common/form/CorporateBanner";
import { LostItemFilter, TableSearch } from "../../../../components/common/svg/AllSvg";
import { useEffect, useState } from "react";
import { useSitemap } from "../../../../shared/hooks/use-sitemap";
import { useSelector } from "react-redux";
import useAxios from "../../../../shared/hooks/use-axios";
import { url } from "../../../../shared/utils/url";
import PaginationComponent from "../../../../components/common/form/PaginationComponent";
import EmptyList from "../../../../components/common/form/EmptyList";
import NoSearch from "../../../../components/common/form/NoSearch";
import Error from "../../../../components/common/form/Error";
import moment from "moment";
import { Link } from "react-router-dom";
import Img1 from "../../../../assets/images/news1.png";
import Img2 from "../../../../assets/images/news2.png";
import Img3 from "../../../../assets/images/news3.png";
import Img4 from "../../../../assets/images/news4.png";

const PressReleases = () => {
    const { t } = useTranslation('common');
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [search, setSearch] = useState<string>("")
    const [debouncedValue, setDebouncedValue] = useState<string>(search);
    const [searchFocus, setSearchFocus] = useState<boolean>(false)
    const [data, setData] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [page, setPage] = useState<number>(1);
    const [total, setTotal] = useState<number>(0);
    const [size, setSize] = useState<any>({ label: `10 ${t("recruitment.home.per_page")}`, value: "10" });
    let totalPages: number = Math.ceil(total / +size?.value);
    const loaderData: any[] = [1, 2, 3, 4, 5]
    useSitemap();

    const getPressReleases = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url.press_release}?page=${page}&size=${+size?.value}${!!debouncedValue ? `&search=${debouncedValue}` : ''}`);

            if (res && res.status === 200) {
                setData(res?.data?.results)
                setTotal(res?.data?.count)
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            setIsError(true)
            console.error("error while fetching press release", error);
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(search);
        }, 500);

        return () => clearTimeout(timer);
    }, [search]);

    useEffect(() => {
        window.scrollTo(0, 0);
        !!lang && getPressReleases();
    }, [lang, debouncedValue, page])

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.press_release.title")}</title>
                <meta name="description" content={t("seo_friendly.press_release.desc")} />
            </Helmet>

            <div className='bg-white dark:bg-bgDarkDull'>
                <CorporateBanner title={t("corporate.content_pages.press_release.title")} root1={t("corporate.content_pages.photo_gallery.home")} root2={t("corporate.content_pages.photo_gallery.media")} root3={t("corporate.content_pages.press_release.title")} />
                <div id="home" className="w-full container pt-[30px] xsm:pt-[40px] xlx:pt-[60px] pb-[60px] xsm:pb-[70px] lg:pb-[90px] xlx:pb-[110px] flex flex-col gap-[20px] mms:!px-[30px]">
                    {(!!search || data?.length > 0) && <div className="w-full flex items-center justify-end gap-[10px]">
                        <div className={`border border-[#EAEAEA] dark:border-gray-700 h-[35px] xlx:h-[40px] px-[12px] xlx:px-[15px] flex items-center gap-[7px] xlx:gap-[9px] w-full xsm:w-[280px] xlx:w-[315px] ${searchFocus && "shadow-xl"} hover:shadow-xl`}>
                            <TableSearch className="xlx:w-[18px] xlx:min-w-[18px] xlx:h-[18px] min-w-[15px] w-[15px] h-[15px] fill-blackDull dark:fill-textBlackDull" />
                            <input type="text" className="text-blackDull font-semibold placeholder:text-blackDull text-sm leading-tight w-full bg-transparent dark:text-textBlackDull placeholder:dark:text-textBlackDull placeholder:text-opacity-[0.5] dark:placeholder:text-opacity-[0.5]" placeholder={t("corporate.content_pages.press_release.search")} autoComplete="off" value={search} onChange={(e: any) => { setSearch(e.target.value) }} onFocus={() => setSearchFocus(true)} onBlur={() => setSearchFocus(false)} />
                        </div>

                        {/* <button className="border border-[#EAEAEA] dark:border-gray-700 h-[34px] xlx:h-[39px] min-w-[34px] xlx:min-w-[39px] flex items-center justify-center focus:shadow-xl hover:shadow-xl">
                            <LostItemFilter className="fill-blackDull dark:fill-textBlackDull" />
                        </button> */}
                    </div>}

                    {loading ?
                        <div className="w-full grid grid-cols-1 xlsm:grid-cols-2 msm:grid-cols-3 xl:grid-cols-4 gap-[15px] xlx:gap-[20px]">
                            {Array.isArray(loaderData) && loaderData.map((item: any, index: number) => (
                                <div key={index} className="border border-[#EAEAEA] w-full flex flex-col p-[10px] xlx:p-[14px] animate-pulse">
                                    <div className="flex items-center justify-center w-full h-[170px] bg-gray-300 rounded-sm dark:bg-gray-700">
                                        <svg className="w-[50px] h-[50px] text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                                            <path className="w-full" d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                                        </svg>
                                    </div>
                                    <div className="flex flex-col gap-[10px] xlx:gap-[14px] pt-[10px] xlx:pt-[14px]">
                                        <div className="flex items-center gap-[10px]">
                                            <div className="w-[90px] h-[25px] rounded-full bg-gray-300 dark:bg-gray-700"></div>
                                            <div className="w-[90px] h-[25px] rounded-full bg-gray-300 dark:bg-gray-700"></div>
                                        </div>

                                        <div className="flex flex-col gap-[8px] w-full">
                                            <div className="bg-gray-200 dark:dark:bg-gray-700 rounded-full h-[12px] w-full"></div>
                                            <div className="bg-gray-200 dark:dark:bg-gray-700 rounded-full h-[12px] w-[50%]"></div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        :
                        <>
                            {isError ?
                                <Error />
                                : <>
                                    {data?.length > 0 && <>
                                        <div className="w-full grid grid-cols-1 xlsm:grid-cols-2 msm:grid-cols-3 xl:grid-cols-4 gap-[15px] xlx:gap-[20px]">
                                            {Array.isArray(data) && data?.map((item: any, index: number) => (
                                                <Link to={item?.document?.url} target="_blank" key={index} className="border border-[#EAEAEA] dark:border-gray-700 hover:border-transparent dark:hover:border-transparent hover:bg-[#F8F8F8] hover:dark:bg-gray-800 focus:border-transparent dark:focus:border-transparent focus:bg-[#F8F8F8] focus:dark:bg-gray-800 w-full flex flex-col p-[10px] xlx:p-[14px]">
                                                    <img src={(!!item?.image?.url ? item?.image?.url : (index + 1) % 4 === 1 ? Img1 : (index + 1) % 4 === 2 ? Img2 : (index + 1) % 4 === 3 ? Img3 : (index + 1) % 4 === 4 ? Img4 : Img4)} alt={item?.title} className={`w-full h-[170px] ${!!!item?.image?.url && 'news-img opacity-[0.6]'}`} />
                                                    <div className="flex flex-col gap-[10px] xlx:gap-[14px] pt-[10px] xlx:pt-[14px]">
                                                        <div className="flex items-center gap-[10px]">
                                                            <div className="flex items-center justify-center px-[13px] h-[25px] rounded-[15px] bg-primary bg-opacity-[0.1] text-primary text-[0.813rem] font-semibold">{moment(item?.published_date).format('DD MMM YYYY')}</div>
                                                            {item?.latest && <div className="flex items-center justify-center px-[13px] h-[25px] rounded-[15px] bg-secOrange bg-opacity-[0.1] text-secOrange text-[0.813rem] font-semibold">{t("corporate.content_pages.news.latest")}</div>}
                                                        </div>

                                                        <h4 className="text-primaryText dark:text-white font-bold line-clamp-2 *:text-primaryText *:dark:text-white *:font-bold *:line-clamp-2 *:text-lg" dangerouslySetInnerHTML={{ __html: !!item?.title ? item?.title : item?.body }} />
                                                    </div>
                                                </Link>
                                            ))}
                                        </div>
                                        <div className="flex items-center justify-center w-full mt-[10px]">
                                            <PaginationComponent
                                                page={page}
                                                total={totalPages}
                                                setPage={setPage}
                                            />
                                        </div>
                                    </>}

                                    {((!!!search) && data?.length === 0) &&
                                        <EmptyList />
                                    }

                                    {((!!search) && data?.length === 0) &&
                                        <NoSearch onClick={() => { setSearch("") }} />
                                    }
                                </>}
                        </>}
                </div>
            </div>
        </>
    );
};

export default PressReleases;